<template>
<div class="grid">
<div class="col-12">
<div class="py-3 mb-4 ">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-else>
  
<template v-if="supplierbrands.length>1">
  <TabView :scrollable="true">

    <TabPanel v-for="supplierbrand in supplierbrands" :header="supplierbrand.brand.name+' - '+supplierbrand.name">
    <SupplierDashboardProjects :supplier="supplierbrand"></SupplierDashboardProjects>


    </TabPanel>
  </TabView>
</template>





<template v-else-if="supplierbrands.length==1">

  <SupplierDashboardProjects :supplier="supplierbrands[0]"></SupplierDashboardProjects>

</template>

<template v-else>
  none
</template>


</template>







</div>
</div>
</div>
</template>
<script>
import SupplierDashboardProjects from "./SupplierDashboardProjects"
export default {

  name: 'SupplierDashboardProjectWrap',

   data () {
    return {
    	supplierbrands:[],
    	loading:true,
    }
  },
  components:{SupplierDashboardProjects},
  mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
  	{
      this.loading = true
  		this.supplierbrands = await this.generalApiGet("supplier_brands_for_dashboard") 
  		console.log("supplierbrands")
      console.log(this.supplierbrands)
      this.loading = false


  	},
  }
}
</script>

<style lang="css" scoped>
</style>